<template>
  <form class="form-new-benchmarks">
    <div class="form-new-benchmarks__container">
      <v-text-field
        v-model="valueBenchmarksName"
        class="text-field-group"
        :label="labels.benchmarksName"
      />

      <v-text-field
        v-model="valueUserGroup"
        class="text-field-group"
        :label="labels.userGroup"
        :rules="[rules.isUserGroupValid]"
        @blur="getUserGroups"
      >
        <v-progress-circular
          v-if="isLoading"
          slot="append"
          indeterminate
          :width="2"
          :size="20"
        />
        <v-icon
          v-else
          slot="append"
          class="invalid"
          :color="isUserGroupValid ? 'green' : 'red'"
        >
          {{ getInputIcon }}
        </v-icon>
      </v-text-field>

      <div class="form-new-benchmarks__trial">
        <v-checkbox
          v-model="displayRadio"
          label="Trial"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <DsIcon
                name="questions"
                size="small"
                class="form-new-benchmarks__tooltip"
              />
            </v-btn>
          </template>
          <span>{{ labels.tooltip }}</span>
        </v-tooltip>
      </div>

      <v-radio-group
        v-if="displayRadio"
        v-model="selectedRadio"
        class="form-new-benchmarks__radios"
        row
      >
        <v-radio
          v-for="radios in trialRadiosOptions"
          :key="radios.value"
          :label="radios.text"
          :value="radios.value"
        />
      </v-radio-group>
    </div>

    <div class="form-new-benchmarks__wrapper-button">
      <DsButton
        :disabled="isButtonDisabled"
      >
        {{ textButton }}
      </DsButton>
    </div>
  </form>
</template>

<script>
import { DsButton } from '@ds/components';
import { DsIcon } from '@ds/icons';
import CompanyService from '@/services/CompanyService';

export default {
  name: 'FormNewBenchmarks',
  components: {
    DsIcon,
    DsButton,
  },
  data() {
    return {
      labels: {
        benchmarksName: this.$t('Setup.newBenchmarks.form.benchmarksName'),
        userGroup: this.$t('Setup.newBenchmarks.form.userGroup'),
        tooltip: this.$t('Setup.newBenchmarks.form.tooltip'),
        errorText: this.$t('Setup.newBenchmarks.form.errorText'),
      },
      trialRadiosOptions: [
        { text: this.$t('Setup.newBenchmarks.form.trialRadiosOptions.text7days'), value: 7 },
        { text: this.$t('Setup.newBenchmarks.form.trialRadiosOptions.text15days'), value: 15 },
        { text: this.$t('Setup.newBenchmarks.form.trialRadiosOptions.text30days'), value: 30 },
      ],
      valueUserGroup: '',
      displayRadio: false,
      valueBenchmarksName: null,
      selectedRadio: null,
      isUserGroupValid: undefined,
      isLoading: false,
    };
  },
  computed: {
    rules() {
      return {
        isUserGroupValid: this.isUserGroupValid === undefined || (this.isUserGroupValid || this.labels.errorText),
      };
    },
    textButton() {
      return this.displayRadio ? this.$t('Setup.newBenchmarks.form.textButtonRegister') : this.$t('Setup.newBenchmarks.form.textButtonNext');
    },
    isButtonDisabled() {
      const isBenchmarksNameEmpty = !this.valueBenchmarksName;
      const isSelectedEmpty = !this.selectedRadio;
      const isUserGroupValid = this.isUserGroupValid;

      if (this.displayRadio) {
        return (isBenchmarksNameEmpty || !isUserGroupValid || isSelectedEmpty);
      }

      return (isBenchmarksNameEmpty || !isUserGroupValid);
    },
    getInputIcon() {
      const getIcon = this.isUserGroupValid ? 'mdi-check-circle-outline' : 'mdi-cancel';
      return this.isUserGroupValid !== undefined ? getIcon : '';
    },
  },
  watch: {
    valueUserGroup(newValue) {
      if (newValue.length === 0) {
        this.isUserGroupValid = false;
      }
    },
  },
  methods: {
    async getUserGroups() {
      try {
        if (!this.valueUserGroup) {
          this.isUserGroupValid = undefined;
          return;
        }

        if (this.isUserGroupValid) {
          return;
        }

        this.isLoading = true;
        await CompanyService.getCompanyByName({ name: this.valueUserGroup });
        this.isLoading = false;
        this.isUserGroupValid = true;
      } catch (e) {
        this.error = true;
        this.isLoading = false;
        this.isUserGroupValid = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-new-benchmarks {
  &__container {
    min-height: 400px;
  }

  &__trial {
    display: flex;
    align-items: center;
  }

  &__tooltip {
    color: var(--ds-color-text-1);
  }

  &__radios {
    margin: 0;
  }

  &__wrapper-button {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
}

.text-field-group {
  margin: 32px 0;
}
</style>
